var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useTour } from '@reactour/tour';
import { OnboardingPrimaryButton, OnboardingStep } from 'root/src/client/v2/onboarding/components/OnboardingStep';
import toast from 'react-hot-toast';
export const GIVEAWAY_ONBOARDING_STEPS = [
    {
        selector: 'div[data-giveaway-onboarding="enter"]',
        resizeObservables: ['div[data-giveaway-onboarding="enter"]'],
        content: () => {
            return (<OnboardingStep>
					<div className="flex flex-col gap-2">
						<div className="text-black">
							<p className="text-black font-medium text-lg">Enter the Giveaway</p>
							<p className="text-black opacity-60">To participate in the giveaway first of all you should enter!</p>
						</div>
					</div>
				</OnboardingStep>);
        },
    },
    {
        selector: '[data-giveaway-onboarding="entries"]',
        resizeObservables: ['[data-giveaway-onboarding="entries"]'],
        content: () => {
            return (<OnboardingStep disableNext>
					<div className="flex flex-col gap-2">
						<div className="text-black">
							<p className="text-black font-medium text-lg">How winning chances work?</p>
							<ul className="list-disc list-inside space-y-1">
								<li className="text-black opacity-60">Follow or subscribe on Twitch and YouTube to earn entries</li>
								<li className="text-black opacity-60">Every action is a one entry!</li>
								<li className="text-black opacity-60">You should have at least one entry to have a chance win in the Giveaway</li>
								<li className="text-black opacity-60">The more entries, the greater the chance of winning.</li>
							</ul>
						</div>
						<CloseButton />
					</div>
				</OnboardingStep>);
        },
    },
];
const CloseButton = () => {
    const tour = useTour();
    const onClose = () => {
        tour.setIsOpen(false);
    };
    return (<OnboardingPrimaryButton onClick={onClose}>
			Got it!
		</OnboardingPrimaryButton>);
};
export const autoEnterSignInModalParams = {
    onSignIn: () => window.location.reload(),
    popup: true,
    popupOptions: {
        onSuccess: () => __awaiter(void 0, void 0, void 0, function* () {
            window.location.reload();
        }),
        onError: (error) => __awaiter(void 0, void 0, void 0, function* () {
            console.error(error);
            toast.error((error === null || error === void 0 ? void 0 : error.message) || 'Something went wrong!');
        }),
    },
};
